import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="impact-banner" aria-label="Need help now">
      <div className="impact-wrap">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="impact-badge">Need it working today?</p>
          <h2 className="impact-title">Call a setup specialist and stay on the line until it’s fixed.</h2>
          <p className="impact-sub">
            Smart Setup Solutions pairs guided online steps with live help for printers and Wi‑Fi extenders —
            so you’re never stuck mid-install.
          </p>
          <div className="impact-actions">
            <button type="button" className="impact-btn primary" onClick={() => navigate("/contact")}>
              Contact support
            </button>
            <a className="impact-btn secondary" href="/printlab">
              Start printer setup
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
